module.exports = __webpack_public_path__ + "img/10.92030f3a.png";